import { CareerId } from '@common/const/catalog/career';
import { careerIdToLayoutData } from './const';

export const getCareerIcon = (career: CareerId) => careerIdToLayoutData[career].iconComponent;
